import React, { useEffect, useState } from "react";
import {
  GetTheGranularityTrend,
  GetTheMetric,
} from "../_DownloadCSV/CSVDownload";
import { PaperHighlight } from "../../../../Components/CustomPaper";

import Header from "../../../../Features/Header/Header";
import CODE from "../../../../Static/Constants/StatusCodes";
import Events from "../../../../Analytics/Events";
import TimeSeriesSingleAxis from "../../../../Charts/Line/TimeSeriesSingleAxis";
import {
  convertToZoneDate,
  getChartTimeStamp,
} from "../../../../Helper/DatePicker/DateConverter";
import {
  getGranularityData,
  getPackComparision,
} from "../../../../Api/DigitalTwin";
import {
  formatDateWithoutYear,
  monthDictionary,
} from "../../../../Helper/DatePicker/DateFormatters";
function Capacity(props) {
  const hierarchy = props.hierarchy;

  const [capacityData, setCapacityData] = useState({
    data: { metric: [], timeStamp: [] },
    responseStatus: {
      code: -1,
      msg: "Loading",
    },
  });
  const [capacityCSV, setCapacityCSV] = useState({
    data: [],
    responseStatus: { code: 0 },
  });

  function GetCapacityCSV() {
    setCapacityCSV({
      data: [],
      responseStatus: {
        code: -1,
      },
    });
    let obj =
      props.granular === "Raw Data" &&
      props.startDate.toLowerCase().indexOf(":") === -1
        ? GetTheMetric(
            props.batteryID,
            hierarchy.selectedPack.value?.toUpperCase(),
            hierarchy.selectedModule.value?.toUpperCase(),
            hierarchy.selectedCell.value?.toUpperCase(),
            hierarchy.level,
            "capacity",
            [props.dateString[0], props.dateString[1]],
            "Capacity (Ah)"
          )
        : GetTheGranularityTrend(
            props.batteryID,
            hierarchy.selectedPack.value,
            hierarchy.selectedModule.value,
            hierarchy.selectedCell.value,
            hierarchy.level,
            ["capacity"],
            [props.startDate.split(":")[0], props.startDate.split(":")[1]],
            props.granular,
            props.operationType,
            "Capacity (Ah)",
            "Single"
          );
    obj.then((res) => {
      if (res?.responseStatus?.code === CODE.SUCCESS)
        setCapacityCSV({
          data: res?.data,
          responseStatus: {
            code: res?.responseStatus?.code,
          },
        });
      else
        setCapacityCSV({
          data: [],
          responseStatus: {
            code: res?.responseStatus?.code,
          },
        });
    });
  }

  useEffect(() => {
    setCapacityData({
      data: { metric: [], timeStamp: [] },
      responseStatus: {
        code: -1,
        msg: "Loading",
      },
    });

    if (props.startDate !== "") {
      if (
        props.granular === "Raw Data" &&
        props.startDate.toLowerCase().indexOf(":") === -1
      ) {
        getPackComparision(
          props.batteryID,
          hierarchy.selectedPack.value?.toUpperCase(),
          hierarchy.selectedModule.value?.toUpperCase(),
          hierarchy.selectedCell.value?.toUpperCase(),
          hierarchy.level,
          "capacity",
          [props.startDate, props.startDate]
        ).then((res) => {
          if (res?.responseStatus?.code === CODE.SUCCESS) {
            let tempData = [];
            res?.response?.batteryData?.map((item) => {
              tempData.push({
                x: getChartTimeStamp(item.batteryDateTime, true),
                y:
                  item["metricsArray"].find((i) => i.type === "capacity")
                    ?.value === undefined
                    ? null
                    : item["metricsArray"].find((i) => i.type === "capacity")
                        ?.value,
              });
            });
            setCapacityData({
              data: tempData,
              responseStatus: {
                code: res?.responseStatus?.code,
                msg: res?.responseStatus?.msg,
              },
            });
          } else {
            setCapacityData({
              data: [],
              responseStatus: {
                code: res?.responseStatus?.code,
                msg: res?.responseStatus?.msg,
              },
            });
          }
        });
      } else if (
        props.granular !== "Raw Data" &&
        props.startDate.toLowerCase().indexOf(":") !== -1
      ) {
        let date = props.startDate.split(":");

        getGranularityData(
          props.batteryID,
          hierarchy.selectedPack.value,
          hierarchy.selectedModule.value,
          hierarchy.selectedCell.value,
          hierarchy.level,
          ["capacity"],
          [date[0], date[1]],
          props.granular,
          props.operationType
        ).then((res) => {
          let tempData = [];
          res?.response?.batteryData?.map((item) => {
            tempData.push({
              x:
                props.granular === "Daily"
                  ? formatDateWithoutYear(
                      convertToZoneDate(item["range"]["startDate"])
                    )
                  : props.granular === "Monthly"
                  ? monthDictionary.find(
                      (o) => o.name === item["range"]["startDate"].split("-")[1]
                    )["value"]
                  : [
                      [
                        formatDateWithoutYear(
                          convertToZoneDate(item["range"]["startDate"])
                        ) + " - ",
                      ],

                      [
                        formatDateWithoutYear(
                          convertToZoneDate(item["range"]["endDate"])
                        ),
                      ],
                    ],
              y:
                res?.responseStatus?.code === CODE.SUCCESS
                  ? item["metricsArray"][0]["value"]
                  : null,
            });
          });

          setCapacityData({
            data: tempData,
            responseStatus: {
              code: res?.responseStatus?.code,
              msg: res?.responseStatus?.msg,
            },
          });
        });
      }
    }
  }, [
    props.granular,
    props.operationType,
    props.startDate,
    hierarchy.selectedPack.value,
    hierarchy.selectedModule.value,
    hierarchy.selectedCell.value,
    hierarchy.level,
  ]);

  return (
    <PaperHighlight
      elevation={0}
      onMouseEnter={() => Events("SB Hovered Capacity Chart")}
    >
      <Header
        heading={props.generateHeading("Capacity")}
        description="Showing Capacity"
        showIButton={true}
        showThreeDots={false}
        showCSVDownload={true}
        csvData={capacityCSV}
        SetCSVData={GetCapacityCSV}
        setStatusBack={setCapacityCSV}
        id="Capacity"
        page="specificBattery"
      />
      <div className="section" id="Capacity">
        <TimeSeriesSingleAxis
          data={{
            series: [
              {
                name: "Capacity (Ah)",
                data: capacityData.data,
              },
            ],
            colors: ["#00D084"],
            xaxisType: props.granular === "Raw Data" ? "datetime" : "category",

            yAxisTitle: "Capacity (Ah)",
            yAxisColor: "#00D084",
            ymin: 0,
            ymax: 125,

            toolTipDecimalPlaces: 1,

            responseStatus: {
              code: capacityData.responseStatus.code,
              msg: capacityData.responseStatus.msg,
            },
          }}
          startDate={props.startDate}
          granular={props.granular}
        />
      </div>
    </PaperHighlight>
  );
}

export default Capacity;
